import { api } from './api';

// Local development can keep login/orders on the remote API while testing only
// the support service locally. The shared client still handles tokens/refresh.
const localBrowser = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);
const localChatUrl = localBrowser
  ? (process.env.REACT_APP_SUPPORT_CHAT_URL || 'http://127.0.0.1:5001').replace(/\/+$/, '')
  : null;
const config = options => ({ ...options, ...(localChatUrl ? { baseURL: localChatUrl } : {}) });
export const supportChatOrigin = localChatUrl || api.defaults.baseURL || window.location.origin;

export const supportChatApi = {
  get: (url, options) => api.get(url, config(options)),
  post: (url, data, options) => api.post(url, data, config(options)),
  patch: (url, data, options) => api.patch(url, data, config(options)),
};
